<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      <div class="row">
        <div class="col-12">
          <h1 class="title-default">Configurar Resulth Scanntech</h1>
        </div>
      </div>

      <!-- Info: funcionalidade disponível apenas para Resulth -->
      <div class="info-banner">
        <mat-icon class="info-icon">info_outline</mat-icon>
        <div class="info-content">
          <strong>Atenção:</strong> Esta integração funciona somente para o <strong>Resulth</strong>.
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row align-items-start">
            <div class="col-md-2 d-flex" style="margin-top: 6px;">
              <mat-slide-toggle class="app-toggle-compact" formControlName="ativo">Ativo</mat-slide-toggle>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-120">
                <mat-label>ID Empresa</mat-label>
                <input matInput type="number" formControlName="idEmpresa" min="0" class="no-spinner"
                  onwheel="this.blur()" />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>ID Local</mat-label>
                <input matInput type="number" formControlName="idLocal" min="0" class="no-spinner"
                  onwheel="this.blur()" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Usuário</mat-label>
                <input matInput type="text" formControlName="usuario" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Senha</mat-label>
                <input matInput type="text" formControlName="senha" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de URLs -->
      <div class="row mt-4">
        <div class="col-12">
          <h2 class="subtitle-default">URLs</h2>
        </div>
      </div>

      <!-- Lista de URLs existentes -->
      @if(listaUrl && listaUrl.length > 0){
      <div class="row mt-3">
        <div class="col-5">
          @for (url of listaUrl; track $index) {
          <div class="url-item-simple">
            <span class="url-text-simple">{{url}}</span>

            <button mat-mini-fab aria-label="Excluir" class="fab-action default" (click)="removerUrl($index)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          }
        </div>
      </div>
      }

      <div class="row mt-3">
        <div class="col-md-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nova URL</mat-label>
            <input matInput type="url" [(ngModel)]="novaUrl" placeholder="https://teste.exemplo.com"
              [ngModelOptions]="{standalone: true}" />
          </mat-form-field>
        </div>
        <div class="col-md-2">
          <button type="button" mat-button class="btn-secondary" (click)="adicionarUrl()" [disabled]="!novaUrl">
            <mat-icon>add</mat-icon>
            Adicionar URL
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4 d-flex gap-3">
          <button type="submit" mat-flat-button class="btn-primary button-big button-responsivo"
            [disabled]="buttonDesativado">
            @if (!_isLoadingButtonSalvar) {
            Salvar
            } @else {
            <mat-spinner diameter="20"></mat-spinner>
            }
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
